import script from "./TargetListTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./TargetListTable.vue?vue&type=script&lang=ts&setup=true"

import "./TargetListTable.vue?vue&type=style&index=0&id=09807420&scoped=true&lang=css"

import exportComponent from "/Users/ra1to/Desktop/web_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09807420"]])

export default __exports__